<template>
  <div>
    <h4>Varianten</h4>
    <b-alert show>
      <span style="white-space: nowrap">{{ vmProduct.title + ' - ' + vmProduct.variants[activeVariant].title }}</span><br />
      <small>So wird der Titel dieser Produkt-Variante im Shop angezeigt. </small>
      <small>Reservierte sehen nur die, für die das Produkt reserviert ist.</small>
    </b-alert>
    <div class="card">
      <div>
        <VariantsList
            class="variant-list"
            :variants="vmProduct.variants"
            :options="vmProduct.options"
            :customers="customers"
            :productId="vmProduct.id"
            :productTitle="vmProduct.title"
            :containers="containers"
            @variant-deleted="onVariantDeleted"
            @variant-created="onVariantCreated"
            @variant-updated="onVariantUpdated"
        ></VariantsList>
      </div>
    </div>
  </div>
</template>

<script>
import VariantsList from "@/pages/EditProductPage/Variants/VariantsList";
import customers from "@/api/customers";
import containers from "@/api/containers";

export default {
  props: ['product'],
  inject: ['showSuccessAlert'],
  data() {
    return {
      deletedVariants: [],
      vmProduct: {},
      customers: [],
      containers: null,
      activeVariant: 0
    }
  },
  components: {
    VariantsList,
  },
  created(){
    this.vmProduct = {...this.product}
    customers.get().then(data => this.customers = data)
    containers.get().then(response => this.containers = response.data)
  },
  methods: {
    onVariantDeleted(variantId){
      this.vmProduct.variants = this.vmProduct.variants.filter(v => !(v.id === variantId))
      this.showSuccessAlert("Variante gelöscht");
      this.updateProduct()
    },
    onVariantCreated(newVariant){
      this.vmProduct.variants.push(newVariant)
      this.updateProduct()
      this.showSuccessAlert("Variant erstellt");
    },
    onVariantUpdated(variant) {
      const updatedVariant = this.vmProduct.variants.find(v => v.id === variant.id)
      if (updatedVariant !== undefined) {
        const option = variant.selectedOptions.find(o => o.name === 'Title')
        updatedVariant.title = option.value;
      }
      this.updateProduct()
      this.showSuccessAlert("Änderung ist gespeichert");
    },
    updateProduct() {
      this.$store.dispatch('products/fetchProduct', { productId: this.$route.params.id })
    }
  }
}
</script>
